import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import ElementUI from "element-ui";
import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fonts/font.css";
import MetaInfo from "vue-meta-info";

router.beforeEach(async (to, from, next) => {
  axios
    .get(
      // "http://114.116.221.105:9090/gateway/ApiService/api/v3/customer/service/info/H5?source=Magicaja"
      "https://api.magicaja.pe/gateway/ApiService/api/v3/customer/service/info/H5?source=Magicaja"
    )
    .then(({ data }) => {
      localStorage.setItem("customerData", JSON.stringify(data.data));
      next();
    });
});

Vue.use(ElementUI);
Vue.use(MetaInfo);

Vue.config.productionTip = false;
Vue.prototype.$href =
  "https://www.muchamo.com/Muchamo_google_release_v1.0.10_2403191759.apk";

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
